import React from 'react';
import { useAlertUI } from '../hooks/useAlertUI';
import { MobileAlertTrigger } from './MobileAlertTrigger';
import { AlertManagerProps } from '../types';

export const AlertManager: React.FC<AlertManagerProps> = ({
  userInfo = null,
  showMobileTrigger = true,
  triggerClassName = '',
  variant = 'blue',
}) => {
  const { alertCount, showMobileAlerts } = useAlertUI(userInfo);

  const isMobile = () => {
    return (
      window.innerWidth <= 768 ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  };

  return (
    <>
      {showMobileTrigger && isMobile() && alertCount > 0 && (
        <MobileAlertTrigger
          alertCount={alertCount}
          onTrigger={showMobileAlerts}
          className={triggerClassName}
          variant={variant}
        />
      )}
    </>
  );
};
